module.exports = __webpack_public_path__ + "static/media/sr.6905244b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/sr.svg
// module id = 252
// module chunks = 0